import {Component, Injector, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { LoginService, UserService } from '../../shared';
import { InactivityService } from './inactivity.service';

@Component({
    selector: 'jhi-inactivity-modal',
    templateUrl: './inactivity-modal.component.html',
    styleUrls: ['./inactivity-modal.component.scss'],
})
export class InactivityModalComponent implements OnInit, OnDestroy {
    counter: number;
    activeModal: NgbActiveModal;
    isModalActive: boolean;
    isSessionExtended = false;
    currentCountdown; // Interval when modal activated
    @ViewChild('modal') modalRef: NgbActiveModal;
    private subscription: Subscription

    constructor(
        private modalService: NgbModal,
        private userService: UserService,
        private loginService: LoginService,
        private inactivityService: InactivityService,
        private injector: Injector
    ) {}

    ngOnInit(): void {
        this.subscription = this.inactivityService.openModal.subscribe(() => {
            // Implementing userAuth validation in InactivityService directly will
            // lead to cyclic dependency errors from AuthExpiredInterceptor
            this.userService.getIsAuthenticated().subscribe((isAuthenticated) => {
                if (isAuthenticated && !this.isModalActive) {
                    this._openModal();
                }
            });
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    onExtendSession() {
        this.isSessionExtended = true;
        this._clearModalCountdown();
        this._pingServer();
        setTimeout(() => this.activeModal.close(), 3000);
    }

    onLogout() {
        this._clearModalCountdown();
        this.loginService.logout();
        this.activeModal.close();
    }

    private _openModal() {
        this.injector.get<UserService>(UserService).isRememberMe().then(isRememeberMe => {
            if (!isRememeberMe) {
                this.activeModal = this.modalService.open(this.modalRef, {
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false
                });
                // RGAA workaround
                const modalEl = document.querySelector('ngb-modal-window');
                modalEl.setAttribute('aria-label', 'Votre session va bientôt expirer');

                if (this.currentCountdown) {
                    this._clearModalCountdown();
                }
                this._startNewModalCountdown();
            }
        });
    }

    private _clearModalCountdown() {
        clearInterval(this.currentCountdown);
    }

    private _startNewModalCountdown() {
        this.counter = 59;
        this.isSessionExtended = false;
        this.currentCountdown = setInterval(() => {
            if (this.counter === 0) {
                this.onLogout();
                this._clearModalCountdown();
            }
            this.counter--;
        }, 1000);
    }

    /**
     * @brief Sends a request to the server to maintain activity and prevent automatic session expiration
     */
    private _pingServer() {
        this.userService.getIsAuthenticated(true).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/modals/inactivity-modal/inactivity-modal.component.ts